import { ChangeEvent, ClickEvent, LookupModelSearchEvent, Snackbar, TableRowDisplayEvent, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutOverdueEventsList } from "./autogen/AutogenLayoutOverdueEventsList";
import { StringUtil } from "@mcleod/core";

export class OverdueEventsList extends AutogenLayoutOverdueEventsList {
    override onLoad() {
        this.checkboxIsActive.allowIndeterminate = false;
    }

    textboxEventTableNameOnChange(event: ChangeEvent) {
        this.textboxEventTableKey.enabled = !StringUtil.isEmptyString(event.newValue);
        if (!this.textboxEventTableKey.enabled) {
            this.textboxEventTableKey.clear();
        }
    }

    textboxOverdueDateOnChange(event: ChangeEvent) {
        this.textboxDays.enabled = !!event.newValue;
        if (!this.textboxDays.enabled) {
            this.textboxDays.clear();
        }
    }

    textboxEventTableNameBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.status = 'C';
    }

    tableEventsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const checkbox = this.tableEvents.selectCheckboxHandler.getCheckboxInRow(tableRow);
        checkbox.enabled = tableRow.enabled = modelRow.getBoolean("is_active", false);

    }

    tableEventsOnSelect(event: TableSelectionEvent){
        this.buttonCancel.enabled = event.table.selectedRows.length > 0;
    }

    buttonCancelOnClick(event: ClickEvent) {
        const progress = Snackbar.showDownloadSnackbar("Multi-Select Action in progress", "Cancelling Overdue Events...", {persist: true});
        Promise.all(this.tableEvents.selectedRows.map(tableRow => {
            const modelRow = tableRow.data;
            modelRow.set("is_active", false);
            modelRow.set("table_change_event", null);
            return modelRow.post();
        })).then(() => this.mainDataSource.search(this.mainDataSource.lastSearch))
        .finally(() => progress.dismiss());
    }
}